import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
var _hoisted_1 = { class: "w-100 d-flex flex-column justify-content-center pt-3" };
var _hoisted_2 = {
    key: 0,
    class: "alert alert-warning",
    role: "alert"
};
var _hoisted_3 = { key: 1 };
var _hoisted_4 = { key: 2 };
import { onMounted, ref } from 'vue';
import { Modal } from 'bootstrap';
import { useAuthStore } from '@/stores/authStore';
import { useRoute } from 'vue-router';
import DasboardClient from './customer/DasboardClient.vue';
import DashboardAdmin from './admin/DashboardAdmin.vue';
import NotificationSetup from '@/components/NotificationSetup.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Dashboard',
    setup: function (__props) {
        var _a;
        var route = useRoute();
        var auth = useAuthStore();
        var role = ref((_a = auth.user) === null || _a === void 0 ? void 0 : _a.role);
        var isClient = ref(role.value === 'client');
        onMounted(function () {
            if (route.query.shop === 'COMPLETED') {
                localStorage.removeItem('order');
            }
            requestNotificationPermission();
        });
        function requestNotificationPermission() {
            return __awaiter(this, void 0, void 0, function () {
                var permission;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!('Notification' in window)) {
                                alert('Este navegador no soporta notificaciones.');
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, Notification.requestPermission()];
                        case 1:
                            permission = _a.sent();
                            if (permission !== 'granted') {
                                openModal();
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function openModal() {
            var modalElement = document.getElementById('enable-notifications');
            var modalInstance = new Modal(modalElement);
            modalInstance.show();
        }
        return function (_ctx, _cache) {
            var _a, _b, _c;
            var _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (((_b = (_a = _unref(auth).user) === null || _a === void 0 ? void 0 : _a.incompleted) === null || _b === void 0 ? void 0 : _b.length) > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[2] || (_cache[2] = _createElementVNode("p", null, "Debe completar los siguientes datos:", -1)),
                        _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_c = _unref(auth).user) === null || _c === void 0 ? void 0 : _c.incompleted, function (field) {
                                return (_openBlock(), _createElementBlock("li", null, "- " + _toDisplayString(field), 1));
                            }), 256))
                        ]),
                        _createElementVNode("p", null, [
                            _cache[1] || (_cache[1] = _createTextVNode("Para una mejor comunicación y servicio, ")),
                            _createVNode(_component_router_link, { to: "/perfil" }, {
                                default: _withCtx(function () { return _cache[0] || (_cache[0] = [
                                    _createTextVNode("Complete su Perfil")
                                ]); }),
                                _: 1
                            })
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(NotificationSetup),
                (isClient.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(DasboardClient)
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(DashboardAdmin)
                    ])),
                _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"modal fade\" id=\"enable-notifications\" tabindex=\"-1\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\"><h3 class=\"text-center\">Necesita habilitar las notificaciones para una mejor comunicación con el sistema.</h3></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-secondary\" data-bs-dismiss=\"modal\">Cerrar</button></div></div></div></div>", 1))
            ]));
        };
    }
});
